import D3Range from './d3Range'
export default D3Range
